export default {
  namespaced: true,
  state: {
    articles: [],
    article: {}
  },
  mutations: {
    setArticles(state, articles) {
      state.articles = articles;
    },
    setArticle(state, article) {
      state.article = article;
    }
  },
  actions: {
    getArticles(context, params) {
      return new Promise((resolve, reject) => {
        var urlParams = new URLSearchParams(params).toString();
        window.axios
          .get(`/articles?${urlParams}`)
          .then(response => {
            context.commit("setArticles", response.data.results);
            resolve();
          })
          .catch(reject);
      });
    },
    getArticle(context, id) {
      return new Promise((resolve, reject) => {
        window.axios
          .get(`/articles/article/${id}`)
          .then(response => {
            context.commit("setArticle", response.data);
            resolve();
          })
          .catch(reject);
      });
    }
  }
};
